import { HighlighterSwipe } from "./illustrations";

/**
 * Wraps inline text in a highlighter-marker SVG. The swipe sits behind the
 * text via absolute positioning so the text remains selectable and readable.
 *
 * Usage: <Highlight color="amber">read-a-thons</Highlight>
 *
 * Available colors map to palette HSL values in illustrations.jsx.
 */
const SWIPE_COLORS = {
  amber:  "hsl(38 90% 50%)",
  clay:   "hsl(16 65% 48%)",
  forest: "hsl(160 25% 32%)",
  sky:    "hsl(200 60% 40%)",
};

// Same marker shape as HighlighterSwipe, as a background image so it can repeat per line.
function swipeBackground(fill) {
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 40" preserveAspectRatio="none"><path d="M3 10Q72 5 197 8L195 32Q107 29 4 35Z" fill="${fill}" opacity="0.3"/><path d="M7 32Q99 28 192 31" stroke="${fill}" stroke-width="3" opacity="0.16" fill="none"/></svg>`;
  return `url("data:image/svg+xml,${encodeURIComponent(svg)}")`;
}

/**
 * `wraps` renders the swipe as a per-line background (box-decoration-break:
 * clone) so a long phrase can wrap on narrow screens with one swipe per line,
 * instead of one stretched swipe behind an unbreakable block.
 */
export default function Highlight({ children, color = "amber", className = "", wraps = false }) {
  const fill = SWIPE_COLORS[color] || SWIPE_COLORS.amber;
  if (wraps) {
    return (
      <span
        className={className}
        style={{
          backgroundImage: swipeBackground(fill),
          backgroundSize: "100% 100%",
          backgroundRepeat: "no-repeat",
          paddingBottom: "0.06em",
          WebkitBoxDecorationBreak: "clone",
          boxDecorationBreak: "clone",
        }}
      >
        {children}
      </span>
    );
  }
  return (
    <span className={`relative inline-block ${className}`}>
      <span className="absolute inset-x-0 -bottom-1 top-1 pointer-events-none">
        <HighlighterSwipe color={fill} className="w-full h-full" />
      </span>
      <span className="relative">{children}</span>
    </span>
  );
}
